// extracted by mini-css-extract-plugin
export default {"dialogSubheading":"dialogSubheading__3dSDJ"};